import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const attachFileDialogEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "issue-navigator-attach-file-dialog-entrypoint" */ './ui/AttachFileDialogNew.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
